/* eslint-disable react/style-prop-object */
import React from 'react';
import { FormattedNumber } from 'react-intl';

export default function Percent({ ...rest }: any) {
  return (
    <FormattedNumber minimumSignificantDigits={3} {...rest} style="percent" />
  );
}
